import { render, staticRenderFns } from "./CountryList.vue?vue&type=template&id=3c8e497d&scoped=true"
import script from "./CountryList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountryList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CountryList.vue?vue&type=style&index=0&id=3c8e497d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8e497d",
  null
  
)

export default component.exports